// @owners { team: patient-health }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import { Card, H1, SecondaryPage, XxxlPadding, useScreenSize } from '@alto/design-system';
import { MessageWithSubject } from '@alto/features';
import React from 'react';
import { goBack } from 'react-router-redux';
import { type AssistantCategory, type AssistantChatOrigin } from '~shared/features/alto-assistant/constants';
import { type MessageTag } from '~shared/features/messages/constants';
import { useDispatchShared } from '~shared/store';

export type MessageFormProps = {
  readonly category: AssistantCategory;
  readonly isEditableSubject?: boolean;
  readonly messagePrompt?: string;
  readonly origin: AssistantChatOrigin;
  readonly prefilledMessage?: string;
  readonly subject?: string;
  readonly tag?: MessageTag;
  readonly userID: number;
};

export const MessageForm = () => {
  const { isMDScreenOrBigger } = useScreenSize();
  const dispatch = useDispatchShared();

  return (
    <SecondaryPage
      headerBackgroundColor={COLORS.BACKGROUND_COLORS.SECONDARY_LIGHTEST}
      HeaderContent={
        <XxxlPadding
          topPadding={isMDScreenOrBigger ? SPACING.STATIC.XXXL : SPACING.STATIC.MD}
          bottomPadding={isMDScreenOrBigger ? SPACING.STATIC.XXXL : SPACING.STATIC.XL}
          leftPadding={SPACING.STATIC.MD}
          rightPadding={SPACING.STATIC.MD}
        >
          <H1 center>New Message</H1>
        </XxxlPadding>
      }
      dismissIcon="chevronleft"
      onDismiss={() => {
        dispatch(goBack());
      }}
    >
      <Card>
        <MessageWithSubject />
      </Card>
    </SecondaryPage>
  );
};
